<script lang="ts">
  import type { CinemaSponsoredProduct } from "../types/CinemaProductsDto.types";

  interface Props {
    variations: CinemaSponsoredProduct[];
    onDsaClick: () => void;
  }

  const { variations, onDsaClick }: Props = $props();
</script>

<div class="spa-cinema-header">
  <h2>Verwandte Produkte zu diesem Artikel</h2>
  <div class="sponsored-link-container">
    <button
      class="sponsored-hint"
      onclick={onDsaClick}
      aria-label="Warum sehe ich diese Werbung?"
    >
      <span class="sponsored-hint-title">gesponsert</span>
      <oc-icon-v1 type="info-hint" size={"50"}></oc-icon-v1>
    </button>
  </div>
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";
  @use "@otto-ec/otto-components-utils/scss/mixins";

  .spa-cinema-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin: tokens.$oc-semantic-spacing-100;
  }

  .spa-cinema-header > h2 {
    font: tokens.$oc-semantic-font-headline-100;
    @include mixins.breakpoint-from-l() {
      font: tokens.$oc-semantic-font-headline-200;
    }
  }

  .sponsored-hint {
    /*            */
    appearance: none;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    font: inherit;

    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: tokens.$oc-base-font-size-75;
    color: tokens.$oc-semantic-color-text-secondary;
  }

  .sponsored-hint-title {
    padding: 0 tokens.$oc-semantic-spacing-25;
  }

  .sponsored-link-container {
    display: flex;
    justify-content: flex-end;
  }

  @media (hover: hover) {
    .sponsored-hint:hover {
      color: tokens.$oc-semantic-color-text-default;
    }
  }
</style>
